/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCompartment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h8.618l2 4H22v16H2zm2 2v16h16V8h-8.618l-2-4zm3 8v-2h2v2h2v2H9v2H7v-2H5v-2zm8.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM12 13.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCompartment as Compartment };
